import { RouteComponentProps } from "react-router-dom";
import { Failure, Landing, Loading, Recording, Recovering, Transcribing } from "./pages";
import { AudioBackupAndRealTimeTranscriptionConnection } from "./pages/common";

export enum TranscriptionRoutePathNames {
  Landing = 'landing',
  Loading = 'loading',
  Recording = 'recording',
  Recovering = 'recovering',
  Transcribing = 'transcribing',
  Failure = 'failure'
};

interface ITranscriptionAppRoute {
  name: string,
  pathname: TranscriptionRoutePathNames,
  component: React.ComponentType<RouteComponentProps<{}, {}, AudioBackupAndRealTimeTranscriptionConnection>>
};

export const routes: ITranscriptionAppRoute[] = [
  {
    name: 'Failure',
    pathname: TranscriptionRoutePathNames.Failure,
    component: Failure
  },
  {
    name: 'Landing',
    pathname: TranscriptionRoutePathNames.Landing,
    component: Landing
  },
  {
    name: 'Loading',
    pathname: TranscriptionRoutePathNames.Loading,
    component: Loading
  },
  {
    name: 'Recording',
    pathname: TranscriptionRoutePathNames.Recording,
    component: Recording
  },
  {
    name: 'Recovering',
    pathname: TranscriptionRoutePathNames.Recovering,
    component: Recovering
  },
  {
    name: 'Transcribing',
    pathname: TranscriptionRoutePathNames.Transcribing,
    component: Transcribing
  }
];